import { HeaderState } from '../objects/headerState';
import { HeaderActionTypes, SET_AVAILABLE_CLIENT_BRANCHES, SET_CONFIG, SET_GOOGLE, TOGGLE_IS_BI, UPDATE_QUOTA } from './actionTypes';

const initialState: HeaderState = {
    actual_active_agency: 0,
    actual_users: 0,
    agency_quota: 0,
    client_id: null,
    email_2fa_bo: false,
    favicon: null,
    google: null,
    keys: [],
    logo: null,
    quotation_code: null,
    quota_active_agency: 0,
    quota_user_bo: 0,
    retrieved: false,
    user_quota: 0,
    agency_group: null,
    has_crm: false,
    has_cms: false,
    main_color: null,
    is_bi: false,
    publishable_contents: [],
    users_assistant: { contract: 0, actual: 0 },
    users_bo: { contract: 0, actual: 0 },
    users_cms: { contract: 0, actual: 0 },
    users_commercial: { contract: 0, actual: 0 },
    users_crm: { contract: 0, actual: 0 },
    users_documentation_only: { contract: 0, actual: 0 },
    users_finance: { contract: 0, actual: 0 },
    users_free_licence: { actual: 0 },
    users_half_licence: { contract: 0, actual: 0 },
    users_owner: { contract: 0, actual: 0 },
    available_client_branches: [],
};

export default (state = initialState, action: HeaderActionTypes): HeaderState => {
    switch (action.type) {
        case SET_CONFIG: {
            const { auth_setting, client_id, logo, keys, favicon, quota_users_bo, quotation_code, agency_group, has_crm, has_cms, publishable_contents, main_color } = action.payload;
            return {
                ...state,
                client_id: client_id,
                email_2fa_bo: !!(auth_setting && auth_setting.email_2fa_bo),
                favicon: favicon,
                keys: keys,
                logo: logo,
                retrieved: true,
                user_quota: quota_users_bo,
                quotation_code: quotation_code,
                // quotation_code: 'mci',
                agency_group: agency_group || null,
                has_crm: !!has_crm,
                has_cms: !!has_cms,
                publishable_contents,
                main_color: main_color ?? null
            };
        }
        case SET_GOOGLE: {
            return { ...state, google: action.payload };
        }
        case UPDATE_QUOTA: {
            const {
                actual_active_agency, actual_users, quota_active_agency, quota_user_bo,
                users_assistant, users_bo, users_cms, users_commercial, users_crm,
                users_documentation_only, users_finance, users_free_licence,
                users_half_licence, users_owner
            } = action.payload;
            return {
                ...state,
                actual_active_agency: actual_active_agency,
                actual_users: actual_users,
                quota_active_agency: quota_active_agency,
                quota_user_bo: quota_user_bo,
                users_assistant: users_assistant ?? state.users_assistant,
                users_bo: users_bo ?? state.users_bo,
                users_cms: users_cms ?? state.users_cms,
                users_commercial: users_commercial ?? state.users_commercial,
                users_crm: users_crm ?? state.users_crm,
                users_documentation_only: users_documentation_only ?? state.users_documentation_only,
                users_finance: users_finance ?? state.users_finance,
                users_free_licence: users_free_licence ?? state.users_free_licence,
                users_half_licence: users_half_licence ?? state.users_half_licence,
                users_owner: users_owner ?? state.users_owner,
            };
        }
        case TOGGLE_IS_BI: {
            return { ...state, is_bi: action.payload };
        }
        case SET_AVAILABLE_CLIENT_BRANCHES: {
            return { ...state, available_client_branches: action.payload };
        }
        default:
            return state;
    }
};